import { render, staticRenderFns } from "./ProgramOverviewForm.vue?vue&type=template&id=450dc241"
import script from "./ProgramOverviewForm.vue?vue&type=script&lang=js"
export * from "./ProgramOverviewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports